import React, {Component} from 'react';
import PropTypes from 'prop-types';

import './CountdownTimer.scss';

class CountdownTimer extends Component {

    constructor(props) {
        super(props);

        const {time} = props;

        this.state = {val: parseInt(time)};
        this.poller = undefined;
    };

    countdown = () => {
        if (this.state.val > 0) {
            this.setState({val: this.state.val - 1,});
        } else {
            this.props.cb();
            this.setState({val: this.props.time,});
        }
    };

    componentDidMount = () => {
        this.poller = setInterval(this.countdown, 1000);
    };

    componentWillMount() {
        this.poller && clearInterval(this.poller);
    }

    render() {
        return (
            <div className="countdownTimer">
                <div id="countdown-number">{this.state.val}</div>
                <svg>
                    <circle r="22.5" cx="25" cy="25" style={{
                        animation: `countdown ${this.props.time + 1}s linear infinite forwards`,
                    }}/>
                </svg>
            </div>
        )
    }
}

CountdownTimer.propTypes = {
    time: PropTypes.number.isRequired,
    cb: PropTypes.func,
};

export default CountdownTimer;
